
import { defineComponent } from "vue";

let timeout = 0;

export default defineComponent({
  name: "App",
  data() {
    return {
      info: "",
      show: false,
    };
  },
  methods: {
    goto(link: string) {
      window.open(link, "_self");
    },
    showInfo(i: number) {
      clearTimeout(timeout);

      if (!this.isMobile()) {
        switch (i) {
          case 0:
            this.$data.info =
              "Entre como <b>colaborador</b> da escola, podendo gerenciar disciplinas, assuntos financeiros, relatórios entre outros.";
            break;
          case 1:
            this.$data.info =
              "Entre como <b>aluno</b>, podendo ver comunicados, avaliações e boletins, diário de classe, solicitações de secretaria entre outros.";
            break;
          case 2:
            this.$data.info = "Ir para o site principal da instituição.";
            break;
          default:
            break;
        }
        this.$data.show = true;
      }
    },
    hideInfo() {
      const temp = this.$data.info;
      timeout = setTimeout(() => {
        if (this.$data.info == temp) {
          this.$data.show = false;
        }
      }, 2000);
    },
    keepInfo() {
      clearTimeout(timeout);
    },
    isMobile() {
      return [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
      ].some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
      });
    },
  },
});
